import React, { useEffect, useState } from "react";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import classes from "./index.module.css";
import { Link, useNavigate } from "react-router-dom";
// import "../assets/css/index.css";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderName, ToggleSideBar } from "../Redux/actions/userActions";
import useIsMobile from "../Utilities/useIsMobile";
import { isAdminRole, hasPermission } from "../Utilities/permissions";
// import { getLanguagedataFunction } from "../utilities/language";
import {
  AuditTrialIcon,
  CallIcon,
  CommunicationIcon,
  CustomerIcon,
  DashboardIcon,
  FeedbackIcon,
  InvoicingIcon,
  ReferralsIcon,
  ReportsIcon,
  SubsManagementIcon,
  TicketsIcon,
} from "./Icons/Icons";

const SideNavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const togglesidebar = useSelector((state) => state.userLogin.togglesidebar);
  const isMobile = useIsMobile();
  // In the mobile overlay drawer we always show full labels.
  const showLabels = togglesidebar || isMobile;
  const [currentRoute, setCurrentRoute] = useState(
    window.location.pathname.toLowerCase()
  );

  const handleNavigate = (name, route) => {
    dispatch(setHeaderName(name));
    setCurrentRoute(route);
    // Auto-close the drawer after navigating on mobile.
    if (isMobile) {
      dispatch(ToggleSideBar(false));
    }
  };

  useEffect(() => {
    console.log(currentRoute);
  }, [currentRoute]);

  useEffect(() => {
    // const currentUser = JSON.parse(sessionStorage.getItem("userInfo"));
    if (!userInfo || !userInfo.token) {
      return navigate("/login");
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    if (window.location.pathname.includes("my-profile")) {
      setCurrentRoute("dashboard");
      return;
    }
    const path = window.location.pathname;
    const Arr = path.split("/");
    const name = Arr[Arr.length - 1].toString();
    setCurrentRoute(name);
  }, [window.location.pathname]);

  return (
    <div id="scrollbar">
      <div>
        {userInfo && isAdminRole(userInfo) && (
          <div
            className={classes.nabBarContainer}
            style={{ height: window.outerHeight, minHeight: "750px" }}
          >
            {hasPermission(userInfo,"dashboard") ? (
              <Link
                className={
                  currentRoute.includes("dashboard") ? `${classes.activebtn}` : ``
                }
              >
                <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                  <Button
                    variant="text"
                    onClick={() => handleNavigate("dashboard", "/dashboard")}
                    className={classes.linkburron}
                  >
                    <span className={classes.activeIcon1}>
                      <DashboardIcon />
                    </span>
                    {showLabels ? "Dashboard" : null}
                  </Button>
                </li>
              </Link>
            ) : null}
            {hasPermission(userInfo,"customers") ? (
              <Link
                to="/customers"
                className={
                  currentRoute.includes("customers") ? `${classes.activebtn}` : ``
                }
                onClick={() => handleNavigate("customers", "/customers")}
              >
                <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                  <Button variant="text" className={classes.linkburron}>
                    <span className={classes.activeIcon1}>
                      <CustomerIcon />
                    </span>{" "}
                    {showLabels ? "Customers" : null}
                  </Button>
                </li>
              </Link>
            ) : null}
            {hasPermission(userInfo,"subscriptionManagement") ? (
              <Link
                to="/subscription-management"
                className={
                  currentRoute.includes("subscription-management")
                    ? `${classes.activebtn}`
                    : ``
                }
                onClick={() =>
                  handleNavigate(
                    "subscription-management",
                    "/subscription-management"
                  )
                }
              >
                <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                  <Button variant="text" className={classes.linkburron}>
                    <span className={classes.activeIcon1}>
                      <SubsManagementIcon />
                    </span>{" "}
                    {showLabels ? "Subscription Management" : null}
                  </Button>
                </li>
              </Link>
            ) : null}
            {hasPermission(userInfo,"referrals") ? (
              <Link
                to="/referrals"
                className={
                  currentRoute.includes("referrals") ? `${classes.activebtn}` : ``
                }
                onClick={() => handleNavigate("referrals", "/referrals")}
              >
                <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                  <Button
                    variant="text"
                    className={classes.linkburron}
                  >
                    <span className={classes.activeIcon1}>
                      <ReferralsIcon />
                    </span>
                    {showLabels ? "Referrals" : null}
                  </Button>
                </li>
              </Link>
            ) : null}
            {hasPermission(userInfo,"invoicing") ? (
              <Link
                to="/invoicing"
                className={
                  currentRoute.includes("invoicing") ? `${classes.activebtn}` : ``
                }
                onClick={() => handleNavigate("invoicing", "/invoicing")}
              >
                <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                  <Button variant="text" className={classes.linkburron}>
                    <span className={classes.activeIcon1}>
                      <InvoicingIcon />
                    </span>
                    {showLabels ? "Invoicing" : null}
                  </Button>
                </li>
              </Link>
            ) : null}
            {hasPermission(userInfo,"auditTrail") ? (
              <Link
                to="/audit-trial"
                className={
                  currentRoute.includes("audit-trial") ? `${classes.activebtn}` : ``
                }
                onClick={() => handleNavigate("audit-trial", "/audit-trial")}
              >
                <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                  <Button variant="text" className={classes.linkburron}>
                    <span className={classes.activeIcon1}>
                      <AuditTrialIcon />
                    </span>
                    {showLabels ? "Audit Trail" : null}
                  </Button>
                </li>
              </Link>
            ) : null}
            {hasPermission(userInfo,"reports") ? (
              <Link
                to="/reports"
                className={
                  currentRoute.includes("reports") ? `${classes.activebtn}` : ``
                }
                onClick={() => handleNavigate("reports", "/reports")}
              >
                <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                  <Button
                    variant="text"
                    className={classes.linkburron}
                  >
                    <span className={classes.activeIcon1}>
                      <ReportsIcon />
                    </span>
                    {showLabels ? "Reports" : null}
                  </Button>
                </li>
              </Link>
            ) : null}
            {hasPermission(userInfo,"communication") ? (
              <Link
                to="/communication"
                className={
                  currentRoute.includes("communication") ? `${classes.activebtn}` : ``
                }
                onClick={() => handleNavigate("communication", "/communication")}
              >
                <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                  <Button
                    variant="text"
                    className={classes.linkburron}
                  >
                    <span className={classes.activeIcon1}>
                      <CommunicationIcon />
                    </span>
                    {showLabels ? "Communication" : null}
                  </Button>
                </li>
              </Link>
            ) : null}
            {hasPermission(userInfo,"supportTickets") ? (
              <Link
                to="/support-tickets"
                className={
                  currentRoute.includes("support-tickets") ? `${classes.activebtn}` : ``
                }
                onClick={() => handleNavigate("support-tickets", "/support-tickets")}
              >
                <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                  <Button
                    variant="text"
                    className={classes.linkburron}
                  >
                    <span className={classes.activeIcon1}>
                      <TicketsIcon />
                    </span>
                    {showLabels ? "Support Tickets" : null}
                  </Button>
                </li>
              </Link>
            ) : null}
            {hasPermission(userInfo,"feedback") ? (
              <Link
                to="/feedback"
                className={
                  currentRoute.includes("feedback") ? `${classes.activebtn}` : ``
                }
                onClick={() => handleNavigate("feedback", "/feedback")}
              >
                <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                  <Button
                    variant="text"
                    className={classes.linkburron}
                  >
                    <span className={classes.activeIcon1}>
                      <FeedbackIcon />
                    </span>
                    {showLabels ? "Feedback" : null}
                  </Button>
                </li>
              </Link>
            ) : null}
            <Link
              to="/contact-us"
              className={
                currentRoute.includes("contact-us") ? `${classes.activebtn}` : ``
              }
              onClick={() => handleNavigate("contact-us", "/contact-us")}
            >
              <li className={!showLabels ? `${classes.linkbtn}` : ``}>
                <Button
                  variant="text"
                  className={classes.linkburron}
                >
                  <span className={classes.activeIcon1}>
                    <CallIcon />
                  </span>
                  {showLabels ? "Contact Us" : null}
                </Button>
              </li>
            </Link>
          </div>
        )}
      </div>
      {/* Sidebar */}
    </div>
  );
};

export default SideNavBar;
